import { createAction } from 'redux-act'

import { XhrError } from 'types'

import { User } from './types/user'

const setXhrErrorCode = createAction<XhrError>('set xhr error code')
const resetXhrErrorCode = createAction('reset xhr error code')

const setScreenType = createAction('set screen type')

const fetchSettingsStart = createAction('fetch settings start')
const fetchSettingsSuccess = createAction('fetch settings success')
const fetchSettingsFail = createAction('fetch settings fail')

const fetchConfigStart = createAction('fetch config start')
const fetchConfigSuccess = createAction<Object>('fetch config success')
const fetchConfigFail = createAction<Object>('fetch config fail')

const toggleLoaders = createAction('toggle loaders')

const fetchUserStart = createAction('fetch user start')
const fetchUserSuccess = createAction('fetch user success')
const fetchUserFail = createAction('fetch user fail')

const fetchToggleFlagsStart = createAction('fetch feature toggle flags start')
const fetchToggleFlagsSuccess = createAction<any>('fetch feature toggle flags success')
const fetchToggleFlagsFail = createAction<any>('fetch feature toggle flags fail')

const trackEvent = createAction<Object>('track event')

const trackESalesEvent = createAction('track esales event')

const changeCustomerType = createAction('CHANGE_CUSTOMER_TYPE')
const changeCustomerStatus = createAction('change customer status')

const updateUser = createAction<Partial<User>>('UPDATE_USER')

const showErrorModal = createAction('show error modal')
const closeErrorModal = createAction<any>('close error modal')
const setPreviousFNSubscribeState = createAction<boolean>('set previous FN subscribe state')
const setIsSendAgainClicked = createAction<boolean>('set send again clicked')
const setIsSendAgainAlreadyClicked = createAction<boolean>('set send again already clicked')
const setIsChallengesBannerTrackingSent = createAction<boolean>(
  'set entry point challenges banner view tracking already sent',
)
export const setMiddlePageEmail = createAction<string>(
  'Sets the email inputted by user in middle page',
)

export default {
  setXhrErrorCode,
  resetXhrErrorCode,
  setScreenType,
  fetchSettingsStart,
  fetchSettingsSuccess,
  fetchSettingsFail,
  fetchConfigStart,
  fetchConfigSuccess,
  fetchConfigFail,
  toggleLoaders,
  fetchUserStart,
  fetchUserSuccess,
  fetchUserFail,
  fetchToggleFlagsStart,
  fetchToggleFlagsSuccess,
  fetchToggleFlagsFail,
  trackEvent,
  trackESalesEvent,
  changeCustomerType,
  changeCustomerStatus,
  updateUser,
  showErrorModal,
  closeErrorModal,
  setPreviousFNSubscribeState,
  setIsSendAgainClicked,
  setIsSendAgainAlreadyClicked,
  setIsChallengesBannerTrackingSent,
}
